"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrailMaker = void 0;

var Utils_1 = require("../../../../Utils");

var Modes_1 = require("../../../../Enums/Modes");

var TrailMaker = /*#__PURE__*/function () {
  function TrailMaker(container) {
    _classCallCheck(this, TrailMaker);

    this.container = container;
    this.delay = 0;
  }

  _createClass(TrailMaker, [{
    key: "interact",
    value: function interact(delta) {
      var container = this.container;
      var options = container.options;
      var trailOptions = options.interactivity.modes.trail;
      var optDelay = trailOptions.delay * 1000;

      if (this.delay < optDelay) {
        this.delay += delta.value;
      }

      if (this.delay >= optDelay) {
        container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
        this.delay -= optDelay;
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var options = container.options;
      var mouse = container.interactivity.mouse;
      var events = options.interactivity.events;
      return mouse.clicking && mouse.inside && !!mouse.position && Utils_1.Utils.isInArray(Modes_1.ClickMode.trail, events.onClick.mode) || mouse.inside && !!mouse.position && Utils_1.Utils.isInArray(Modes_1.HoverMode.trail, events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return TrailMaker;
}();

exports.TrailMaker = TrailMaker;